import { PROMOTION_ERROR_CODE } from '@rc-d2c/context-manager';

export const getErrorMsgKey = (errCode: string) => {
  switch (errCode) {
    case PROMOTION_ERROR_CODE.EXPIRED:
      return 'cart.cardTotal.promotion.error.expired';
    case PROMOTION_ERROR_CODE.NOT_VALID:
      return 'cart.cardTotal.promotion.error.notValid';
    case PROMOTION_ERROR_CODE.UNKNOWN:
      return 'cart.cardTotal.promotion.error.default';

    default:
      return 'common.error.default';
  }
};
